import { isAxiosError } from "axios";

/**
 * ネストされたオブジェクト/配列から文字列メッセージを再帰的に収集する。
 */
const collectMessages = (value: unknown): string[] => {
  if (typeof value === "string") return [value];
  if (Array.isArray(value)) return value.flatMap(collectMessages);
  if (value && typeof value === "object") {
    return Object.values(value).flatMap(collectMessages);
  }
  return [];
};

/**
 * Axios エラーレスポンスから詳細メッセージを抽出する。
 * `{ field: ["msg"] }` や `{ components: [{ file: ["msg"] }] }` のようなネスト構造を走査し、
 * 含まれる文字列メッセージをすべて結合して返す。
 */
export const extractFileError = (error: unknown): string | null => {
  if (!isAxiosError<unknown>(error)) return null;
  const data = error.response?.data;
  if (!data) return null;
  const messages = [...new Set(collectMessages(data).filter(Boolean))];
  return messages.length > 0 ? messages.join("\n") : null;
};
